module.exports = __webpack_public_path__ + "static/media/checkcirclecenter.ccd3d6f1.svg";